'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.skinProps = exports.mastheadExtensionProps = exports.mastheadProps = exports.searchProps = exports.mainMenuProps = exports.userMenuProps = exports.sectionMenuObjectProps = exports.mastheadExtensionHeaderProps = exports.sectionProps = exports.svgProps = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable import/no-mutable-exports */
var svgProps = exports.svgProps = void 0;
var sectionProps = exports.sectionProps = void 0;
var mastheadExtensionHeaderProps = exports.mastheadExtensionHeaderProps = void 0;
var sectionMenuObjectProps = exports.sectionMenuObjectProps = void 0;
var userMenuProps = exports.userMenuProps = void 0;
var mainMenuProps = exports.mainMenuProps = void 0;
var searchProps = exports.searchProps = void 0;
var mastheadProps = exports.mastheadProps = void 0;
var mastheadExtensionProps = exports.mastheadExtensionProps = void 0;
var skinProps = exports.skinProps = void 0;

if (process.env.NODE_ENV !== 'production') {
    exports.svgProps = svgProps = {
        name: _propTypes2.default.string.isRequired,
        shape: _propTypes2.default.element.isRequired,
        viewbox: _propTypes2.default.string.isRequired,
        label: _propTypes2.default.string.isRequired,
        theme: _propTypes2.default.shape({
            root: _propTypes2.default.string
        })
    };

    exports.sectionProps = sectionProps = {
        name: _propTypes2.default.string.isRequired,
        url: _propTypes2.default.string.isRequired
    };

    exports.mastheadExtensionHeaderProps = mastheadExtensionHeaderProps = {
        name: _propTypes2.default.string.isRequired,
        url: _propTypes2.default.string
    };

    exports.sectionMenuObjectProps = sectionMenuObjectProps = {
        path: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.instanceOf(RegExp)]),
        name: _propTypes2.default.string.isRequired,
        url: _propTypes2.default.string,
        mainMenu: _propTypes2.default.bool,
        subSections: _propTypes2.default.arrayOf(_propTypes2.default.shape(sectionProps))
    };

    exports.userMenuProps = userMenuProps = {
        labels: _propTypes2.default.shape({
            login: _propTypes2.default.string,
            logout: _propTypes2.default.string
        }),
        mySite: _propTypes2.default.shape(sectionProps),
        readings: _propTypes2.default.shape(sectionProps),
        benefits: _propTypes2.default.shape((0, _extends3.default)({}, sectionProps, {
            cardUrl: _propTypes2.default.string
        })),
        subscribe: _propTypes2.default.shape(sectionProps).isRequired
    };

    exports.mainMenuProps = mainMenuProps = {
        publicationMenu: _propTypes2.default.arrayOf(_propTypes2.default.shape(sectionProps)).isRequired,
        userMenu: _propTypes2.default.shape(userMenuProps).isRequired,
        svg: _propTypes2.default.shape({
            chevron: _propTypes2.default.shape(svgProps).isRequired,
            userHollow: _propTypes2.default.shape(svgProps).isRequired
        }).isRequired
    };

    exports.searchProps = searchProps = {
        url: _propTypes2.default.string.isRequired
    };

    exports.mastheadProps = mastheadProps = {
        labels: _propTypes2.default.shape({
            searchIcon: _propTypes2.default.string,
            menuOpened: _propTypes2.default.string,
            menuClosed: _propTypes2.default.string
        }).isRequired,
        logoUrl: _propTypes2.default.string.isRequired,
        search: _propTypes2.default.shape(searchProps),
        svg: _propTypes2.default.shape({
            logo: _propTypes2.default.shape(svgProps).isRequired,
            search: _propTypes2.default.shape(svgProps).isRequired,
            searchClear: _propTypes2.default.shape(svgProps).isRequired
        }).isRequired
    };

    exports.mastheadExtensionProps = mastheadExtensionProps = {
        svg: _propTypes2.default.shape({
            chevron: _propTypes2.default.shape(svgProps).isRequired
        }).isRequired,
        labels: _propTypes2.default.shape({
            login: _propTypes2.default.string,
            myAccount: _propTypes2.default.string,
            mySubscription: _propTypes2.default.string,
            sectionsDropdown: _propTypes2.default.string
        }).isRequired,
        myPage: _propTypes2.default.shape(sectionProps).isRequired
    };

    exports.skinProps = skinProps = {
        masthead: _propTypes2.default.shape(mastheadProps).isRequired,
        mastheadExtension: _propTypes2.default.shape(mastheadExtensionProps).isRequired,
        mainMenu: _propTypes2.default.shape(mainMenuProps).isRequired,
        importantSections: _propTypes2.default.arrayOf(_propTypes2.default.shape(sectionProps)).isRequired,
        sectionsMenu: _propTypes2.default.arrayOf(_propTypes2.default.shape(sectionMenuObjectProps)).isRequired
    };
} else {
    exports.svgProps = svgProps = {};
    exports.sectionProps = sectionProps = {};
    exports.mastheadExtensionHeaderProps = mastheadExtensionHeaderProps = {};
    exports.sectionMenuObjectProps = sectionMenuObjectProps = {};
    exports.userMenuProps = userMenuProps = {};
    exports.mainMenuProps = mainMenuProps = {};
    exports.searchProps = searchProps = {};
    exports.mastheadProps = mastheadProps = {};
    exports.mastheadExtensionProps = mastheadExtensionProps = {};
    exports.skinProps = skinProps = {};
}
//# sourceMappingURL=index.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/ui-core-navigation/lib/cjs/components/props/index.js
 ** module id = 32
 ** module chunks = 1
 **/